module.exports = __webpack_public_path__ + "static/media/cca.2cb3adab.png";